import React from 'react'

const ConversationScrollContext = React.createContext(null)

const DELAY = 2000

const ConversationScrollProvider = ({ children }) => {
  const [shouldScroll, setShouldScroll] = React.useState(false)

  const triggerScroll = React.useCallback(() => {
    setShouldScroll(true)
  }, [])

  // Resets state after a timeout
  React.useEffect(() => {
    if (!shouldScroll) {
      return
    }

    setTimeout(() => {
      setShouldScroll(false)
    }, DELAY)
  }, [shouldScroll])

  return (
    <ConversationScrollContext.Provider value={{ shouldScroll, triggerScroll }}>
      {children}
    </ConversationScrollContext.Provider>
  )
}

export default ConversationScrollProvider

export const useConversationScroll = () =>
  React.useContext(ConversationScrollContext)
